import { createContext, useContext, useState, useCallback, ReactNode } from 'react';
import { OnboardingSpotlight, useTourSteps } from '../components/onboarding';

interface OnboardingTourContextType {
  isOpen: boolean;
  startTour: () => void;
  closeTour: () => void;
}

const OnboardingTourContext = createContext<OnboardingTourContextType | null>(null);

export function OnboardingTourProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);
  const tourSteps = useTourSteps();

  const startTour = useCallback(() => {
    setIsOpen(true);
  }, []);

  const closeTour = useCallback(() => {
    setIsOpen(false);
  }, []);

  return (
    <OnboardingTourContext.Provider value={{ isOpen, startTour, closeTour }}>
      {children}
      <OnboardingSpotlight
        isOpen={isOpen}
        onClose={closeTour}
        steps={tourSteps}
      />
    </OnboardingTourContext.Provider>
  );
}

export function useOnboardingTour() {
  const context = useContext(OnboardingTourContext);
  if (!context) {
    throw new Error('useOnboardingTour must be used within OnboardingTourProvider');
  }
  return context;
}
